module.exports = __webpack_public_path__ + "static/img/img-1.6cb0ccd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/img-1.png
// module id = H2zR
// module chunks = 0